import React, { useMemo } from 'react';
import { PermissionsContext } from '@britishcouncil/react-common';

import { useGetPermissionsQuery } from 'store';

export const PermissionsProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: permissions } = useGetPermissionsQuery();
  const contextValue = useMemo(() => ({ permissions: permissions ?? [] }), [permissions]);

  return <PermissionsContext.Provider value={contextValue}>{children}</PermissionsContext.Provider>;
};

export const PermissionsProviderMock = ({
  children,
  permissions,
}: {
  children: React.ReactNode;
  permissions: number[];
}) => {
  const contextValue = useMemo(() => ({ permissions }), [permissions]);

  return <PermissionsContext.Provider value={contextValue}>{children}</PermissionsContext.Provider>;
};
